import React from 'react'
import styled from 'styled-components'

import { InputGroup, Label, ErrorLabel, Hint, OptionalTag } from '.'

let AutosizeTextarea = () => {}
if (typeof document !== 'undefined') {
  // eslint-disable-next-line global-require
  AutosizeTextarea = require('react-textarea-autosize').default
}

export const Textarea = styled(AutosizeTextarea)
  .attrs((props) => ({
    minRows: 8,
    ...props,
  }))
  .withConfig({
    shouldForwardProp: (prop) =>
      [
        'rounded',
        'error',
        'readOnly',
        'white',
        'isPlaceholder',
        'grey',
        'noResize',
        'noMargin',
        'smallMargin',
        'minRows',
      ].includes(prop) !== true,
  })`
  width: 100%;
  padding: 18px;
  margin: 8px 0 8px;
  outline: 0;
  resize: vertical;
  color: black;
  border: 1px solid
    ${({ theme, error }) =>
      error ? theme?.['-ds-error-300']?.value : theme.colors.textGreyLight};

  ${({ rounded = true }) =>
    rounded &&
    `
    border-radius: 6px;
  `}

  &:focus {
    border-color: ${({ theme }) => theme.brand.jungle};
  }

  ${({ rounded }) =>
    rounded &&
    `
    border-radius: 6px;
  `}

  ${({ noResize }) =>
    noResize &&
    `
    resize: none;
  `}
`

export const renderTextArea = ({
  input,
  label,
  hint,
  meta: { form, error, submitFailed },
  noSubmitFailed,
  optional,
  bigLabel,
  mediumLabel,
  liteLabel,
  minRows,
  ...custom
}) => (
  <InputGroup {...custom}>
    {label && (
      <Label
        for={`${form}-${input.name}`}
        error={error && (noSubmitFailed || submitFailed)}
        bigLabel={bigLabel}
        mediumLabel={mediumLabel}
        liteLabel={liteLabel}
      >
        {label}
        {optional && <OptionalTag />}
      </Label>
    )}
    <Textarea
      id={`${form}-${input.name}`}
      error={error && (noSubmitFailed || submitFailed)}
      minRows={minRows}
      {...input}
      {...custom}
    />
    {error && (noSubmitFailed || submitFailed) && (
      <ErrorLabel for={input.name}>{error}</ErrorLabel>
    )}
    {hint && <Hint>{hint}</Hint>}
  </InputGroup>
)
